import { useEffect, useState } from 'react';
import { consultarBloqueio, definirBloqueio, fecharPeriodosAte } from '../api';
import { Alert } from './common';

const br = (d) => (d ? d.split('-').reverse().join('/') : null);

/**
 * Trava manual: nada com data igual ou anterior à data-limite entra, exista o
 * período ou não. É o que impede escriturar competência antiga por engano —
 * inclusive pela importação de notas, que cria o período na hora.
 */
export default function TravaEscrituracao({ clienteId, onMudou }) {
  const [st, setSt] = useState(null);
  const [data, setData] = useState('');
  const [motivo, setMotivo] = useState('');
  const [comp, setComp] = useState('');
  const [msg, setMsg] = useState(null);
  const [ocupado, setOcupado] = useState(false);

  const carregar = () => {
    if (!clienteId) return;
    consultarBloqueio(clienteId).then((r) => {
      setSt(r);
      setData(r.bloqueada_ate || '');
    }).catch(() => setSt(null));
  };
  useEffect(carregar, [clienteId]);

  const salvar = async (liberar) => {
    setMsg(null);
    if (!liberar && !data) return setMsg({ tipo: 'danger', txt: 'Informe a data-limite.' });
    if (!motivo.trim()) {
      return setMsg({ tipo: 'danger',
        txt: liberar ? 'Descreva por que a escrituração está sendo liberada.'
                     : 'Descreva o motivo do bloqueio.' });
    }
    setOcupado(true);
    try {
      const r = await definirBloqueio(clienteId, liberar ? null : data, motivo.trim());
      setMsg({ tipo: 'success',
               txt: liberar ? 'Escrituração liberada.'
                            : `Escrituração bloqueada até ${br(data)}.` });
      setMotivo('');
      carregar();
      onMudou?.(r);
    } catch (e) {
      setMsg({ tipo: 'danger', txt: e.message });
    } finally { setOcupado(false); }
  };

  const fecharAte = async () => {
    if (!/^\d{4}-\d{2}$/.test(comp)) return setMsg({ tipo: 'danger', txt: 'Use AAAA-MM.' });
    setOcupado(true);
    setMsg(null);
    try {
      const r = await fecharPeriodosAte(clienteId, comp);
      setMsg({ tipo: 'success',
               txt: r.fechados ? `${r.fechados} período(s) fechado(s): ${r.periodos.join(', ')}`
                               : 'Nenhum período aberto até essa competência.' });
      onMudou?.(r);
    } catch (e) {
      setMsg({ tipo: 'danger', txt: e.message });
    } finally { setOcupado(false); }
  };

  if (!clienteId) return null;
  const travado = !!st?.bloqueada_ate;

  return (
    <div style={{ border: `1px solid ${travado ? '#d9a441' : '#d5dce8'}`, borderRadius: 8,
                  padding: 16, marginBottom: 16,
                  background: travado ? '#fff8e6' : '#fff' }}>
      <div className="flex" style={{ justifyContent: 'space-between', alignItems: 'center',
                                     marginBottom: travado ? 10 : 14 }}>
        <h3 style={{ margin: 0, fontSize: 15 }}>
          {travado ? '🔒 Escrituração bloqueada' : '🔓 Escrituração liberada'}
        </h3>
        {travado && (
          <span style={{ fontWeight: 700, color: '#9c6500' }}>
            até {br(st.bloqueada_ate)}
          </span>
        )}
      </div>

      {travado && (
        <p className="small" style={{ margin: '0 0 12px', color: '#7f5b00' }}>
          {st.motivo}
          {st.bloqueado_por && <> · por {st.bloqueado_por}</>}
          {st.bloqueado_em && <> em {new Date(st.bloqueado_em).toLocaleDateString('pt-BR')}</>}
        </p>
      )}

      {msg && <Alert tipo={msg.tipo}>{msg.txt}</Alert>}

      <div className="flex" style={{ gap: 8, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <label style={{ fontSize: 12 }}>
          Bloquear até<br />
          <input type="date" value={data} onChange={(e) => setData(e.target.value)} />
        </label>
        <label style={{ flex: 1, minWidth: 220, fontSize: 12 }}>
          Motivo<br />
          <input value={motivo} onChange={(e) => setMotivo(e.target.value)}
                 placeholder={travado ? 'por que está liberando' : 'por que está bloqueando'}
                 style={{ width: '100%' }} />
        </label>
        <button className="primary" onClick={() => salvar(false)} disabled={ocupado}>
          {travado ? 'Alterar a data' : 'Bloquear'}
        </button>
        {travado && (
          <button onClick={() => salvar(true)} disabled={ocupado} style={{ color: '#c0392b' }}>
            Liberar
          </button>
        )}
      </div>

      <hr style={{ margin: '14px 0', border: 0, borderTop: '1px solid #e6eaf2' }} />

      <div className="flex" style={{ gap: 8, alignItems: 'flex-end' }}>
        <label style={{ fontSize: 12 }}>
          Fechar todos os períodos até<br />
          <input value={comp} onChange={(e) => setComp(e.target.value)}
                 placeholder="2026-07" style={{ width: 110 }} />
        </label>
        <button onClick={fecharAte} disabled={ocupado}>Fechar em lote</button>
        <span className="small muted" style={{ flex: 1 }}>
          Recusa se houver lançamento em rascunho ou revisão.
        </span>
      </div>

      <p className="small muted" style={{ margin: '12px 0 0' }}>
        A trava vale para tudo que grava lançamento: manual, correção, estorno e a
        apropriação automática das notas fiscais. O fechamento mês a mês continua
        valendo; a data-limite cobre também os meses que ainda não existem.
      </p>
    </div>
  );
}
